import React from "react";
import * as RadixTooltip from "@radix-ui/react-tooltip";
import { cn } from "@/lib/utils";

/**
 * Tooltip primitive built on Radix. `role="tooltip"`, `aria-describedby`
 * wired automatically. Hover + focus trigger.
 *
 *   <Tooltip content="Copy link">
 *     <IconButton icon={Copy} aria-label="Copy" />
 *   </Tooltip>
 */
export function Tooltip({
  children,
  content,
  side = "top",
  align = "center",
  delayDuration = 150,
}) {
  return (
    <RadixTooltip.Provider delayDuration={delayDuration}>
      <RadixTooltip.Root>
        <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <RadixTooltip.Content
            side={side}
            align={align}
            sideOffset={8}
            className={cn(
              "pointer-events-none z-[200] rounded-[6px] bg-frac-black text-frac-white shadow-elev-md",
              "px-[10px] py-[6px] text-[12.5px] font-medium leading-snug",
              "data-[state=delayed-open]:animate-in data-[state=delayed-open]:fade-in-0 data-[state=closed]:animate-out data-[state=closed]:fade-out-0",
            )}
            data-testid="tooltip-content"
          >
            {content}
            <RadixTooltip.Arrow className="fill-frac-black" />
          </RadixTooltip.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
}

export default Tooltip;
